import { useMsal } from "@azure/msal-react";
import React from "react";
import { useIdleTimer } from "react-idle-timer";
import { AppInsightsService } from "../../../telemetry/services/AppInsightsService";
import { CURRENT_USER_EMAIL_KEY, CURRENT_USER_NAME_KEY, CURRENT_USER_NAME_NUMBER_KEY, CURRENT_VIEW_AS_USER_NAME_KEY } from "../../../redux/services/AccountSessionStorage";

export const useIdleHandler = (sessionTimeoutInMinutes?: number): void => {
    const { instance } = useMsal();
    const timeoutMs = 1000 * 60 * (sessionTimeoutInMinutes ?? 28800);
    const lastActivityKey = "members-portal-last-activity";

    const updateLastActivity = React.useCallback(() => {
        localStorage.setItem(lastActivityKey, Date.now().toString());
    }, []);

    const { getRemainingTime, reset } = useIdleTimer({
        timeout: timeoutMs,
        onAction: updateLastActivity,
        onIdle: () => {
			const lastActivity = Number(localStorage.getItem(lastActivityKey));
			if (!Number.isFinite(lastActivity) || Date.now() - lastActivity >= (timeoutMs - 3000)) {
				sessionStorage.setItem("isAuthenticated", "false");
				sessionStorage.setItem("isSignedIn", "false");
				sessionStorage.removeItem(CURRENT_USER_NAME_KEY);
				sessionStorage.removeItem(CURRENT_USER_EMAIL_KEY);
				sessionStorage.removeItem(CURRENT_USER_NAME_NUMBER_KEY);
				sessionStorage.removeItem(CURRENT_VIEW_AS_USER_NAME_KEY);
				sessionStorage.removeItem("menuItems");
				
                AppInsightsService.clearAuthenticatedUser();
                    instance.logoutRedirect({
                        postLogoutRedirectUri: "/",
                    });
                return;
            }
            reset();
        },
        debounce: 500,
    });

    React.useEffect(() => {
        updateLastActivity();
        const handleStorage = (event: StorageEvent) => {
            if (event.key === lastActivityKey) {
                reset();
            }
        };

        window.addEventListener("storage", handleStorage);
        return () => window.removeEventListener("storage", handleStorage);
    }, [reset, updateLastActivity]);
};
